import React, { useState } from "react";
import { Box, Stack, Tabs, Tab } from "@mui/material";
import { useTranslate } from "src/locales";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import PageTwo from "../modal/page-two";
import PageOne from "../modal/page-one";
import ByzNurseAddButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseAddButton";
import PageThere from "../modal/page-there";
import PageFour from "../modal/page-four";
//MPOGLU;453137;09042025
function SafeBirthControl() {
  // const [alertOpen, setAlertOpen] = useState(false);
  // const [alertMessage, setAlertMessage] = useState("");
  // const [alertSeverity, setAlertSeverity] = useState<
  //   "error" | "warning" | "info" | "success"
  // >("success");
  const { t } = useTranslate();
  const [selectedTab, setSelectedTab] = useState<string | number>(
    "application-instant"
  );

  // const showAlert = (
  //   message: string,
  //   severity: "error" | "warning" | "info" | "success"
  // ) => {
  //   setAlertMessage(message);
  //   setAlertSeverity(severity);
  //   setAlertOpen(true);
  // };

  // const handleSaveMedcard = async () => {
  //   try {
  //     const response = "Medcard Kaydedildi";
  //     console.log("Save API cevabı:", response);
  //     showAlert(response, "success");
  //   } catch (error) {
  //     console.error("Hata:", error);
  //     showAlert("Medcard kaydedilirken hata oluştu!", "error");
  //   }
  // };

  // const handleDeleteMedcard = async () => {
  //   try {
  //     const response = "Medcard Silindi";
  //     console.log("Delete API cevabı:", response);
  //     showAlert(response, "success");
  //   } catch (error) {
  //     console.error("Hata:", error);
  //     showAlert("Medcard silinirken hata oluştu!", "error");
  //   }
  // };
  return (
    <>
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
      >
        <ByzNurseSaveButton
          // onClick={handleSaveMedcard}>
          onClick={() => console.log("clicked")}
        ></ByzNurseSaveButton>
        <ByzNurseAddButton></ByzNurseAddButton>
        <ByzNurseDeleteButton
          //onClick={handleDeleteMedcard}
          onClick={() => console.log("clicked")}
        ></ByzNurseDeleteButton>
        <ByzNursePrintButton2></ByzNursePrintButton2>
      </Stack>

      <Box sx={{ padding: "20px", width: "100%" }}>
        <Tabs
          sx={{
            marginBottom: 2,
            "& .MuiTabs-indicator": {
              backgroundColor: "#2979C3",
            },
          }}
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          aria-label="Tabs"
        >
          <Tab
            label={t("safe-birth-control-form.application-instant")}
            value={"application-instant"}
            sx={{
              "&.Mui-selected": {
                color: "#2979C3",
              },
            }}
          />
          <Tab
            label={t("safe-birth-control-form.before-birth")}
            value={"before-birth"}
            sx={{
              "&.Mui-selected": {
                color: "#2979C3",
              },
            }}
          />
          <Tab
            label={t("safe-birth-control-form.after-birth")}
            value={"after-birth"}
            sx={{
              "&.Mui-selected": {
                color: "#2979C3",
              },
            }}
          />
          <Tab
            label={t("safe-birth-control-form.before-discharge")}
            value={'before-discharge'}
            sx={{
              "&.Mui-selected": {
                color: "#2979C3",
              },
            }}
          />
        </Tabs>
        {selectedTab === "application-instant" && <PageOne />}
        {selectedTab === "before-birth" && <PageTwo />}
        {selectedTab === "after-birth" && <PageThere />}
        {selectedTab === "before-discharge" && <PageFour />}
      </Box>
    </>
  );
}

export default SafeBirthControl;
